module.exports = __webpack_public_path__ + "img/megaphone.69fae3ad.gif";